import { UntypedFormControl } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ValidatorCheck {

	isRequired(control: UntypedFormControl): boolean {
		const validatorFn = control.validator as any;
		if (!validatorFn) {
			return false;
		}
		const validators = validatorFn('');
		if (validators === undefined || validators === null) {
			return false;
		}
		return validators.required === true;
	}

}
